"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("../styles/SweetAlertStyles"));
var defaultMessage = 'Please enter a response!';
var emailMessage = 'Please enter a valid email!';
var ValidationMessage = function (_a) {
    var validationMsg = _a.validationMsg, inputType = _a.inputType;
    var message = validationMsg || (inputType === 'email' ? emailMessage : defaultMessage);
    return (react_1.default.createElement("div", { style: styles.validationMessage },
        react_1.default.createElement("div", { style: styles.exclamationIcon }, "!"),
        message));
};
exports.default = ValidationMessage;
//# sourceMappingURL=ValidationMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-sweetalert/dist/components/ValidationMessage.js
// module id = 1858
// module chunks = 0